import React, { useEffect, useMemo } from 'react';

import { PersonalInformationPayload } from '../PersonalInformation/stores/usePersonalInformation.store';

import CheckingWrapper from './CheckingWrapper';
import useGetExistingPoliciesQuery from './useGetExistingPolicies.query';

interface Props {
  employee: Partial<PersonalInformationPayload> | null;
  onSuccess: () => void;
}

const PoliciesChecking: React.FC<Props> = ({ employee, onSuccess }) => {
  const { hasActivePolicy, isLoading, isSuccess } = useGetExistingPoliciesQuery(employee?.employeeId);
  const hasNoActivePolicy = useMemo(() => !isLoading && isSuccess && !hasActivePolicy,
    [hasActivePolicy, isLoading, isSuccess]);

  useEffect(() => {
    if (hasNoActivePolicy) {
      onSuccess();
    }
  }, [hasNoActivePolicy, onSuccess]);

  return (
    <CheckingWrapper
      testId="PoliciesChecking"
      isSuccess={hasNoActivePolicy}
      isLoading={isLoading || !isSuccess}
      title="There are no active policies"
    />
  );
};

export default PoliciesChecking;
